module.exports = __webpack_public_path__ + "static/media/orquestra_salao_1.bf008f7a.jpg";